import api from "../../../services/api";

export const getMarketingEcomm = async (
  month = "2025-04",
  limit = 40
) => {
  const response = await api.get("/api/shopify/marketing/marketing_dashboard", {
    params: { month, limit },
  });
  return response.data;
};
